import { render, staticRenderFns } from "./ServiceAddConfirmation.vue?vue&type=template&id=26f8599e&scoped=true&"
import script from "./ServiceAddConfirmation.vue.js?vue&type=script&lang=js&"
export * from "./ServiceAddConfirmation.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f8599e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
